// Info: Import React Dependancies
import { useCallback, useEffect, useState } from "react";

// Info: Import NPM Dependancies
import { useSearchParams } from "react-router-dom";

// Info: Import Local Dependancies
import Chatbot from "../chatbot";
import config from "../config";
import MessageParser from "../components/ChatComponent/MessageParser";
import ActionProvider from "../components/ChatComponent/ActionProvider";
import { IUserMessage, useProxyServices } from "../services/useProxyService";
import { IMessage } from "../interfaces/IMessages";
import { useSelector } from "react-redux";
import { getAuthToken } from "../store/sitecoreSlice";
import useAuthRefresh from "../hooks/useAuthRefresh";

const Chat = () => {
  const { getMessageHistory } = useProxyServices();
  const [searchParams] = useSearchParams();
  const authToken = useSelector(getAuthToken);
  //const userId = "921561946951124941530778967581606335539";
  // const userId = useLocation().pathname.replace('/en/', '');
  const userId = searchParams?.get("uid");
  const [messageHistory, setMessageHistory] = useState<IMessage[]>([]);

  const getUserMessageHistory = async (id: string) => {
    const res = await getMessageHistory(id);

    const trasformMessages: IMessage[] = res.map(
      (datum: IUserMessage, index: number) => ({
        message: datum.content,
        type: datum.role,
        id: Number(datum.userId),
      })
    );
    setMessageHistory([...trasformMessages]);
  };

  useEffect(() => {
    if (userId && authToken) {
      getUserMessageHistory(userId);
    }
  }, [userId, authToken]);



  return (
    <Chatbot
      config={config}
      messageParser={MessageParser}
      actionProvider={ActionProvider}
      messageHistory={messageHistory}
    />
  );
};

export default Chat;
